import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {BackgroundImageSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/backgroundImage'
import {PrimerComponentSectionIntroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSectionIntro'
import {PrimerCardsSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerCards'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {PrimerComponentStatisticSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentStatistic'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {PrimerComponentStaticFootnotesSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentStaticFootnotes'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

export const TemplateHomeSchema = buildEntrySchemaFor('newsroomTemplateHomepage', {
  fields: z.lazy(() =>
    z.object({
      hero: PrimerComponentHeroSchema,
      heroBackgroundImage: BackgroundImageSchema,
      heroStatistics: safeOptional(z.array(PrimerComponentStatisticSchema)),
      pressReleaseSectionIntro: PrimerComponentSectionIntroSchema,
      pressReleaseSectionCards: PrimerCardsSchema,
      reportsSectionIntro: PrimerComponentSectionIntroSchema,
      reportsSectionCards: PrimerCardsSchema,
      reportsStatisticsHeading: z.string().optional(),
      reportsSectionStatistics: safeOptional(z.array(PrimerComponentStatisticSchema)),
      inTheNewsSectionIntro: PrimerComponentSectionIntroSchema,
      inTheNewsSectionCards: PrimerCardsSchema,
      customerStoriesSectionIntro: safeOptional(PrimerComponentSectionIntroSchema),
      featuredCustomerStories: safeOptional(PrimerCardsSchema),
      ctaSectionImage: safeOptional(AssetSchema),
      ctaSectionHeading: z.string().optional(),
      ctaSectionCards: safeOptional(PrimerCardsSchema),
      ctaBanner: PrimerComponentCtaBannerSchema,
      ctaBannerBackgroundImage: safeOptional(AssetSchema),
      staticFootnotes: safeOptional(PrimerComponentStaticFootnotesSchema),
    }),
  ),
})

export type HomeTemplate = z.infer<typeof TemplateHomeSchema>
